module.exports = __webpack_public_path__ + "img/flex-align-top.3c6297ce.svg";